/*eslint-disable react/no-set-state*/
import React, {PropTypes} from 'react';
import {connect} from 'react-redux';
import {browserHistory} from 'react-router';
import * as pathConstants from '../../constants/pathConstants';
import Button from '../common/Button';
import '../../styles/helpRequest/helpRequest.css';

export class HelpRequestPageConfirmation extends React.Component {
  constructor(props, context) {
    super(props, context);
    this.redirect = this.redirect.bind(this);
  }
  redirect() {
    if (sessionStorage.getItem('helpRedirect') === '1') {
      browserHistory.push(pathConstants.pathToHome);
    }
    else {
      browserHistory.push(pathConstants.pathToLogin);
    }
  }

  render() {
    let buttonText = "";
    if (sessionStorage.getItem('helpRedirect') === '1') {
      buttonText = "Back to Home";
    }
    else {
      buttonText = "Back to Login";
    }
    return (
      <div className="help-desk-confirmation-page">
        <div>
          <p>Thank you for submitting a ticket to the Injury Tracking Application Help Desk!</p>
        </div>
        <div>
          <Button className="btn btn-primary" onClick={this.redirect} value={buttonText}/>
        </div>
      </div>
    );
  }
}

HelpRequestPageConfirmation.propTypes = {
  helpRequestConfirmation: PropTypes.object.isRequired,
  data: PropTypes.object,
};
function mapStateToProps() {
  let helpRequestConfirmation = {};
  return {
    helpRequestConfirmation
  };
}

export default connect(mapStateToProps)(HelpRequestPageConfirmation);



/** WEBPACK FOOTER **
 ** ./src/components/helpRequest/HelpRequestPageConfirmation.js
 **/